import { Component } from '@angular/core';

@Component( {
    selector: 'app-skills',
    templateUrl: './skills.component.html',
    styleUrls: [ './skills.component.css' ],
    standalone: false
} )
export class SkillsComponent { }
